export default __webpack_public_path__ + "static/889-c9495d54bb05cb099c7fcea32affefdd.gif";